import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';

import { EmailContainer } from './EmailInput.styles';

const EmailInput = forwardRef(
  (
    {
      className,
      name,
      onChange,
      placeholder,
      dataCy = 'email-input',
      dataTestId = 'email-input',
      value,
      defaultValue,
      isControlled = true,
      message,
      inline
    },
    ref
  ) => {
    const handleChange = (event) => onChange && onChange(event);

    const inputProps = isControlled ? { value } : { defaultValue, ref };

    return (
      <EmailContainer inline={inline} className={className} data-cy={`${dataCy}-container`}>
        <label htmlFor={name}>{message}</label>
        <input
          {...inputProps}
          data-cy={dataCy}
          data-testid={dataTestId}
          name={name}
          onChange={handleChange}
          placeholder={placeholder}
          type="text"
          id={name}
        />
      </EmailContainer>
    );
  }
);

EmailInput.displayName = 'EmailInput';

EmailInput.propTypes = {
  className: PropTypes.string,
  isControlled: PropTypes.bool,
  name: PropTypes.string,
  onChange: PropTypes.func,
  placeholder: PropTypes.string,
  dataCy: PropTypes.string,
  dataTestId: PropTypes.string,
  value: PropTypes.string,
  defaultValue: PropTypes.string,
  message: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  type: PropTypes.string,
  inline: PropTypes.bool
};

export default EmailInput;
